import { useMutation } from '@hooks/reactQuery';

import { getSiteId } from '@api/manageSite';

import { GENERATE_SITE_ID } from '@constants/queryKeys';

export const useMutateGenerateSiteId = () => {
	const {
		mutate: generateSiteId,
		isLoading: isLoadingGenerateSiteId,
	} = useMutation({
		mutationKey: [GENERATE_SITE_ID],
		mutationFn: ({ setSiteId }: { setSiteId: (id: number) => void }) => getSiteId()
			.then(data => {
				if (data.id >= 0) setSiteId(data.id);
			}),
	});

	return {
		generateSiteId,
		isLoadingGenerateSiteId,
	};
};
